<template>
  <div>
    <b-row>
      <template v-if="item.field_condition.length && item.field_condition[0]">
        <b-col sm="12">
          <InputSelect
            :class="['mb-2 w-25', inputClass]"
            textFloat="Choose a field value type"
            title="Value Type"
            name="type"
            isRequired
            v-model="item.field_condition[0].value"
            v-bind:options="typeOption"
            @onDataChange="numberType = 1"
            valueField="value"
            textField="name"
            :disabled="!isEditable"
          />
        </b-col>
        <b-col
          sm="6"
          v-if="item.field_condition[0].value == 'number'"
          class="mt-auto pr-1"
        >
          <InputSelect
            textFloat="Choose a field type"
            title=""
            name="type"
            v-model="numberType"
            v-bind:options="numberOption"
            @onDataChange="changeNumberType"
            valueField="value"
            textField="name"
            class="mb-2"
            :disabled="!isEditable"
          />
        </b-col>
        <b-col
          :class="item.field_condition[0].value == 'text' ? '' : 'pl-1'"
          :sm="item.field_condition[0].value == 'text' ? '12' : '6'"
          v-if="item.field_condition[0].value == 'text' || numberType == 1"
          class="mt-auto"
        >
          <InputText
            class="text-float-normal mb-2"
            textFloat="Length"
            v-model="item.field_condition[1].value"
            placeholder="Length"
            type="number"
            :disabled="!isEditable"
          />
        </b-col>
      </template>

      <b-col sm="6" v-if="numberType == 2" class="pl-1">
        <div class="d-flex align-items-center">
          <InputText
            class="mr-1 text-float-normal mb-2"
            textFloat="Min"
            v-model="item.field_condition[2].value"
            placeholder="Min"
            type="number"
            :disabled="!isEditable"
          />
          <InputText
            class="ml-1 text-float-normal mb-2"
            textFloat="Max"
            v-model="item.field_condition[3].value"
            placeholder="Max"
            type="number"
            :disabled="!isEditable"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
export default {
  name: "FieldTextDetail",
  components: {
    InputText,
    InputSelect,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
    inputClass: {
      required: false,
      type: String,
    },
    isEditable: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: true,
      isBusy: false,
      numberType: 1,
      typeOption: [
        { value: "text", name: "Character" },
        { value: "number", name: "Numberic" },
      ],
      numberOption: [
        { value: 1, name: "Length" },
        { value: 2, name: "Min-Max" },
      ],
    };
  },
  watch: {
    item: {
      handler() {
        this.checkTypeCondition();
      },
      immediate: true,
    },
  },

  methods: {
    changeNumberType(value) {
      if (value == 1) {
        this.item.field_condition[2].value = "";
        this.item.field_condition[3].value = "";
      } else {
        this.item.field_condition[1].value = "";
      }
    },
    checkTypeCondition() {
      if (
        this.item.field_condition.length &&
        this.item.field_condition[0].value == "number"
      ) {
        if (this.item.field_condition[1].value) {
          this.numberType = 1;
        } else if (
          this.item.field_condition[2].value ||
          this.item.field_condition[3].value
        ) {
          this.numberType = 2;
        }
      } else {
        this.numberType = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .text-float-normal .input-custom {
  label {
    color: #5b5b5b;
    font-size: 16px;
    font-weight: 100;
  }
}
::v-deep .custom-select {
  height: 38px;
}

::v-deep .select-custom {
  label {
    color: #5b5b5b;
    font-size: 16px;
    font-weight: 100;
  }
}
</style>
